import React from 'react';
import { timeRangeOptions } from './constants/options';
import { useTotalAnalytics } from './hooks/useTotalAnalytics';
import { useSummaryData } from './hooks/useSummaryData';
import { useUserSummaryData } from './hooks/useUserSummaryData';
import TopMetrics from './components/TopMetrics';
import GamicsSection from './components/GamicsSection';
import UsersSection from './components/UsersSection';
import CampaignsSection from './components/CampaignsSection';
import DevelopersSection from './components/DevelopersSection';
import { useDeveloperSummaryData } from './hooks/useDeveloperSummaryData';

const Dashboard: React.FC = () => {
  const totalAnalytics = useTotalAnalytics();
  const {
    summaryDataGamic,
    summaryDataCampaign,
    chartDataGamic,
    chartDataCampaign,
    timeRangeGamic,
    timeRangeCampaign,
    setTimeRangeGamic,
    setTimeRangeCampaign,
  } = useSummaryData();
  const { userSummaryData, userChartData, userTimeRange, setUserTimeRange } =
    useUserSummaryData();
  const { developerSummaryData, developerChartData, developerTimeRange, setDeveloperTimeRange } =
    useDeveloperSummaryData();

  const stats = [
    { label: 'Total Users', value: totalAnalytics?.total_users },
    { label: 'Total Developers', value: totalAnalytics?.total_publisher },
    {
      label: 'Total Approved Gamics',
      value: totalAnalytics?.total_approved_gamics,
    },
    {
      label: 'Total Active Campaigns',
      value: totalAnalytics?.total_active_campaigns,
    },
  ];

  return (
    <div className='space-y-[32px]'>
      <TopMetrics stats={stats} />
      <GamicsSection
        summaryData={summaryDataGamic}
        chartData={chartDataGamic}
        timeRange={timeRangeGamic}
        setTimeRange={setTimeRangeGamic}
        timeRangeOptions={timeRangeOptions}
      />
      <UsersSection
        {...{
          userSummaryData,
          userChartData,
          userTimeRange,
          setUserTimeRange,
          timeRangeOptions,
        }}
      />
      <CampaignsSection
        summaryData={summaryDataCampaign}
        chartData={chartDataCampaign}
        timeRange={timeRangeCampaign}
        setTimeRange={setTimeRangeCampaign}
        timeRangeOptions={timeRangeOptions}
      />
      <DevelopersSection
      {...{
          developerSummaryData,
          developerChartData,
          developerTimeRange,
          setDeveloperTimeRange,
          timeRangeOptions,
        }}
         />
    </div>
  );
};

export default Dashboard;